/*! KIM Specific */
$(function() {

	$(function() {

    var mobile = false;
    var tablet = false;
    var desktop = false;

    function checkWidth() {

      var viewportWidth = window.viewportSize.getWidth();

      if (viewportWidth <= 660) {
        if (!mobile) {
          $('.header-inner .search').insertAfter('.header-container nav');
          $('.header-inner .shop-cart').insertAfter("#btn-main-nav")
          $('.flexslider ul li a').not('.flexslider ul.flex-direction-nav li a').contents().unwrap();
          // $('#btn-search').insertBefore('div.shop-cart');
          $('.footer-container .email-signup').prependTo('.footer-container');
          $('body').addClass('mobile');
        }
        mobile = true;
        desktop = false;
        tablet = false;
      } 
      
      else if (viewportWidth >= 661 && viewportWidth <= 960) {
        if (!tablet) {
          $('.header-inner .search').insertAfter('.header-inner #btn-search');
          // $('#btn-search').insertBefore('div.shop-cart');
          $('.header-inner .shop-cart').insertAfter("#btn-main-nav")
          $('.footer-container .email-signup').prependTo('.footer-container div.inner-wrap');
          $('ul.breadcrumb').insertBefore('#category-nav');
          $('body').removeClass('mobile');
        }
        mobile = false;
        desktop = false;
        tablet = true;
      } 
      
      else {
        if (!desktop) {
          $('.header-inner .search').insertAfter('.header-inner #btn-search');
          // $('#btn-search').prependTo('div.utilities');
          $('.header-inner .shop-cart').insertAfter(".main-nav")
          $('.footer-container .email-signup').insertAfter('.footer-container div.contact');
          $('ul.breadcrumb').insertAfter('div.cat-hdr');
          $('body').removeClass('mobile');
        }
        mobile = false;
        desktop = true;
        tablet = false;
      }
    }

    checkWidth();
    
    $(window).on("resize", checkWidth);
  });

	///Menus
  $(function() {

    function closeSearch() {
      $("#btn-search").toggleClass('search-inactive search-active');
	    $("div.search").slideToggle('fast');
    }

    function closeTopNav() {
      $("#btn-main-nav").toggleClass('inactive activated')
      $('.main-nav nav .top-nav').slideToggle('fast');
    }

    $("#btn-search").on("click", function() {
      $(this).toggleClass('search-inactive search-active');
	    $("div.search").slideToggle('fast');
      if ($(".top-nav").is(":visible")) {
        closeTopNav()
      }
	    $("#tSearchString").trigger("focus");
    });

    function closeLeftNav() {
      $("#btn-left-nav").toggleClass('leftnav-active leftnav-inactive ').next().removeClass('nav-opened');
    }

    $("#btn-left-nav").on("click", function() {
      if ($(this).hasClass("leftnav-inactive")) {
        $("div.left-nav").animate({
          left: '0px'
        }, 200, 'linear');
        $(this).toggleClass('leftnav-inactive leftnav-active').next().addClass('nav-opened');
      } else {
        $("div.left-nav").animate({
          left: '-350px'
        }, 200, 'linear');
        closeLeftNav()
      }
      return false;
    });
    
    $("#btn-main-nav").on("click", function() {
      if ($(".left-nav").hasClass('nav-opened')) {
        $("div.left-nav").animate({
          left: '-350px'
        }, 200, 'linear');
        closeLeftNav()
      }
        if ($("div.search").is(":visible")) { 
          closeSearch();
        }
      $(this).toggleClass('inactive activated')
      $('.main-nav nav .top-nav').slideToggle('fast');
    });
  });
	 
//Product Page Item description collapse and tabs
$(function () {
  const $tabLinksWrap = $('#tabs > .tab-links');
  const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);

  $("#tabs > div").hide();
  $("#tabs > div:first").show();
  $tabFirstBtn.addClass('active');
  
  $tabLinksWrap.on('click', 'button', function () {
    const $this = $(this);
    const $sibling = $this.siblings();

    $sibling.removeClass('active').attr({
      'tabindex': '-1',
      'aria-selected': 'false'
    });

    $this.addClass('active').attr({
      'tabindex': '0',
      'aria-selected': 'true'
    });

    var currentTab = $this.attr('aria-controls');
    $("#tabs > div").hide();
    $(`#${currentTab}`).show();

    return false;
  });
});
  
  //Equalize Columns
  $(function() {

    var equalheight = function(container) {
      var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el, topPosition = 0;
      $(container).each(function() {
        $el = $(this);
        $($el).height('auto')
        topPosition = $el.position().top;

        if (currentRowStart != topPosition) {
          for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
          rowDivs.length = 0;
          currentRowStart = topPosition;
          currentTallest = $el.height();
          rowDivs.push($el);
        } else {
          rowDivs.push($el);
          currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
      });
    }

    const equalheightLoad = function () { 
      equalheight('.prod-list ul li');
      equalheight('.search-ctg .ctg-grey-box h3');
    }
    
    window.addEventListener('load', equalheightLoad);
    window.addEventListener('resize', equalheightLoad);
  });
  
   
  var root = document.getElementsByTagName( 'html' )[0];
  if(!document.createElement('svg').getAttributeNS){
  	root.setAttribute( "class", "no-svg" );
    return;
  }

      /* ADA AAA
    Main navigation menu */
    $(function () {
      var $dropdowns = $("#main-nav .dropdown");
      var $dropdownsLinks = $("#main-nav .dropdownLink");
      $dropdownsLinks.on("focus",function(){
        let $thisParent = $(this).parent();
        $dropdowns.removeClass("open");
        $dropdownsLinks.attr("aria-expanded", "false");
        $thisParent.addClass("open");
        $(this).attr("aria-expanded", "true");
      })
  
      $('#main-nav').on("focusout", function() {
          setTimeout(() => {
            // if active element is outside the div.header-container...
            if ($(document.activeElement).parents('#main-nav').length === 0) {
              // remove hover functionality
              $dropdowns.removeClass("open");
              $dropdownsLinks.attr("aria-expanded", "false");
            }
          }, 100);
      })
      /*Hover Intent*/
      var $dropdowns = $('.top-nav > li');
      $dropdowns
          .on('mouseover', function() {
              var $this = $(this);
              if ($this.prop('hoverTimeout')) {
                  $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
              }
              $this.prop('hoverIntent', setTimeout(function() {
                  $this.addClass('open');
              }, 0));
          })
          .on('mouseleave', function() {
              var $this = $(this);
              if ($this.prop('hoverIntent')) {
                  $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
              }
              $this.prop('hoverTimeout', setTimeout(function() {
                  $this.removeClass('open');
              }, 0));
          });
  });

  $(function () {
    $(".subscribe-wrapper .item-subscribe:last-child").hide();
    $(".subscribe-wrapper h2:first-child").addClass("opened");
    $(".subscribe-wrapper h2#monthly-item").addClass("closed");
    $('.accordionButton').on('click', function(event) {
      swapPurchaseType.call(this, event)
    });
  });
  //HP cycleSlide ADA update
  if($('.cycle-carousel').length > 0) {
    function handleNextPrev(_, opt) {
      let activeElement
      opt.slides.each(function (_, el) {
        if (el.classList.contains('cycle-slide-active'))
          activeElement = el
      })
      let focusEl = activeElement.querySelector('a:not(.gallery-prev, .gallery-next)')
      setTimeout(() => {
        focusEl.focus()
      }, 600);
    }
    $('.cycle-carousel').cycle()
      .on('cycle-update-view', function () {
        const wrapper = $(this).find('.cycle-carousel-wrap')
        const active = $(this).find('.cycle-slide-active')
        wrapper.children().each(function (_, el) {
          $(el).find('a').attr("tabindex", -1)
        })
        active.find('a').attr("tabindex", 0)
      })
      .on('cycle-next', handleNextPrev)
      .on('cycle-prev', handleNextPrev)

  }

});


/*End KIM-scripts */